// ADR 7.10.26v §8 — the device's one-page / two-page preference.
//
// 30.9.26h's `prefStore` idiom, so a cached snapshot, `try`/`catch` on every
// read and write, and cross-tab `storage` events. `localStorage` only: a device
// fact like the theme, never sent to the backend and never wiped at sign-out.
// The key is the one x and y store in DataStore / `UserDefaults`. `auto`
// removes the key, and anything unparseable reads `auto`.
//
// The store sits beside the shell, which reads it on the first frame; the
// settings section imports it from here (the existing direction for settings
// stores — `prefStore` is the shared idiom).

import { prefStore, type PrefStore } from '../../features/settings/prefStore'
import type { SpreadPreference } from '../../wasm'

export const SPREAD_PREFERENCE_KEY = 'spread_preference'

/** Membership, keyed unquoted: the stored words the rule accepts. */
const STORED: Record<SpreadPreference, true> = { auto: true, one_page: true, two_pages: true }

/** True only for `auto` — a lookup, never a quoted compare (§7). */
export const IS_AUTO: Record<SpreadPreference, boolean> = { auto: true, one_page: false, two_pages: false }

// Not one of the guarded layout words (7.10.26v §7): `'auto'` is also a CSS value.
export const AUTO: SpreadPreference = 'auto'

function parse(raw: string | null): SpreadPreference {
  return raw !== null && Object.hasOwn(STORED, raw) ? (raw as SpreadPreference) : AUTO
}

function serialize(value: SpreadPreference): string | null {
  return IS_AUTO[value] ? null : value
}

export const spreadPreferenceStore: PrefStore<SpreadPreference> = prefStore(SPREAD_PREFERENCE_KEY, parse, serialize)
